import { EMPTY_ARRAY } from '@applyonline/shared';
import { useQuery } from '@tanstack/react-query';
import apiClient from './api-client';
const SCOPE = 'skip-bank-request';
const DETAIL = 'detail';
const keysFactory = {
    all: (financingProgram) => [{ scope: SCOPE, financingProgram }],
    allDetails: (financingProgram) => [{ scope: SCOPE, entity: DETAIL, financingProgram }],
    detail: (id, financingProgram) => [{ scope: SCOPE, entity: DETAIL, id, financingProgram }],
};
const createGetSkipBankRequestRequirements = (financingProgram) => {
    return async ({ queryKey: [{ id }] }) => {
        const response = await apiClient.get(`/${financingProgram}/creditApplication/${encodeURIComponent(id)}/skipbankrequestrequirements`);
        return response.data;
    };
};
export function useGetSkipBankRequestRequirements(creditApplicationId, financingProgram) {
    const getSkipBankRequestRequirements = createGetSkipBankRequestRequirements(financingProgram);
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.detail(creditApplicationId, financingProgram),
        queryFn: getSkipBankRequestRequirements,
        enabled: !!creditApplicationId,
    });
    return [data ?? EMPTY_ARRAY, isFetching];
}
